<template>
  <v-card class="ma-2">
    <v-col>
      <v-checkbox
          label="Acepto esta tarifa de precios y me comprometo al pago de la factura emitida, incluidos aquellos casos en los que no proceda garantía del producto reparado.  "
          v-model="terms"
          v-if="formType == 'sat'"
          :rules="[rules.required]"/>

      <v-checkbox
          label=""
          v-model="privacy"
          :rules="[rules.required]">
        <template v-slot:label>
          <div>
            <b>Acepto la
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a v-if="company === 'fibraclim'"
                     target="_blank"
                     href="https://fibraclim.com/content/8-politica-de-privacidad"
                     @click.stop
                     v-on="on"
                  >
                    Política de privacidad.
                  </a>
                  <a v-if="company === 'climahosteleria'"
                     target="_blank"
                     href="https://climahosteleria.es/content/29-politica-de-privacidad"
                     @click.stop
                     v-on="on"
                  >
                    Política de privacidad.
                  </a>
                  <a v-if="company === 'arilex'"
                     target="_blank"
                     href="https://arilex.es/es/content/11-politica-de-privacidad"
                     @click.stop
                     v-on="on"
                  >
                    Política de privacidad.
                  </a>
                </template>
                Abrir en una nueva pestaña
              </v-tooltip>
            </b>
            <br/>
            <span v-if="company === 'fibraclim'">Fibraclim </span>
            <span v-if="company === 'climahosteleria'">Climahosteleria </span>
            <span v-if="company === 'arilex'">Arilex </span>
            se encuentra profundamente comprometido con el cumplimiento de la normativa en protección de
            datos
            de
            carácter personal, y garantiza el cumplimiento íntegro de las obligaciones dispuestas, así como la
            implementación
            de las medidas de seguridad técnicas y organizativas, según lo establecido en la normativa 3/2018 de
            Protección de
            Datos y Garantía de los Derechos Digitales (LOPD-GDD) y el Reglamento General de Protección de Datos de
            Europa UE 2016/679 (RGPD).
          </div>
        </template>
      </v-checkbox>

      <v-row align="center" justify="center">
        <v-btn class="ma-2 white--text" color="red" @click="onCancel">Cancelar</v-btn>
        <v-btn class="ma-2" color="primary" @click="onSend">Enviar</v-btn>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "Actions",
  props: ["company", "formType"],
  data() {
    return {
      terms: false,
      privacy: false,
      rules: {
        required: value => !!value || 'Es obligatorio aceptar los términos y condiciones.'
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onSend() {
      this.$emit('send', {terms: this.terms, privacy: this.privacy})
    }
  }
}
</script>

<style scoped>

</style>